<form role="form" #jobBoardsCredentialsForm="ngForm" novalidate>
    <div class="row" *ngIf="(typeOfCompany != 'Client')">
        <div class="col-xs-12">
            <div class="main-box">
                <div class="main-box-body clearfix">
                    <br />
                    <h2 style="color: #03a9f4;"><b>Job Boards</b></h2>
                    <br />
                    <div class="col-xs-11 col-sm-10">
                        <table width="100%">
                            <tr *ngIf="(typeOfCompany == 'Company' || typeOfCompany == 'Host') && isUserSuperUserOr4dot5Admin">
                                <td width="23%">
                                    <label for="daxtraDbName" class="control-label">Daxtra DB Name:
                                    </label>
                                </td>
                                <td width="30%" colspan="5">
                                    <input type="text" class="form-control" [(ngModel)]="preferences.daxtraDbName"
                                        [ngClass]="{'border-danger': daxtraDbName.invalid}"
                                        name="daxtraDbName" id="daxtraDbName" #daxtraDbName="ngModel"
                                        [required]="(preferences.jobBoardCredentialList != null) && (preferences.jobBoardCredentialList.length > 0)">
                                </td>
                                <td>
                                    <span class="error" *ngIf="(preferences.jobBoardCredentialList != null) && (preferences.jobBoardCredentialList.length > 0) && daxtraDbName.invalid">Need to have a valid Database Name</span>
                                </td>
                            </tr>
                            <tr>
                                <td width="23%">
                                    <label for="resumesPullCount"
                                        class="control-label">{{MESSAGECONSTANTS.LABLES.WORKFLOW_SETTINGS.RESUMES_TO_PULL_COUNT}}:
                                    </label>
                                </td>
                                <td width="10%" colspan="2">
                                    <select class="form-control"
                                        [(ngModel)]="preferences.resumesToPullPerJobBoardCount" name="resumesPullCount"
                                        id="resumesPullCount"
                                        [disabled]="readOnlyForClientOrBU || (!clientOrBuCreationInProgress && !clientOrBuUpdateInProgress && isCompanyVendor)">
                                        <option *ngFor="let resumePullCount of resumePullCounts" [ngValue]="resumePullCount">{{resumePullCount}}</option>
                                    </select>
                                </td>
                                <td></td>
                            </tr>
                        </table>
                    </div>
                    <br />
                    <h2 style="color: #03a9f4;margin-left: 8px;"><b>Credentials</b></h2>
                    <br />
                    <div class="col-xs-11 col-sm-10">
                        <div *ngIf="(!isActivePlanExists || savedCurrentActivePlanName == 'Trial') && (!isUserSuperUserOr4dot5Admin)">
                            <div style="width:100%;" class="alert alert-danger" role="alert">
                                Since
                                <strong>{{companyName}}</strong> is
                                in <strong>Trial Plan</strong>, <strong>4dot5</strong>'s
                                Indeed Account credentials can be used. Please contact 4dot5 Admin to use your own
                                Job Board credentials.
                            </div>
                        </div>
                        <div
                            *ngIf="((typeOfCompany == 'Company' && savedCurrentActivePlanName !== 'Trial' && (preferences.daxtraDbName == null || preferences.daxtraDbName =='')) || (typeOfCompany == 'BusinessUnit' && !preferences.daxtraDbNamePresentAtCompany)) && (!isUserSuperUserOr4dot5Admin)">
                            <div style="width:100%;" class="alert alert-danger" role="alert">
                                Please contact 4dot5 Admin to use your own Job Board credentials.
                            </div>
                        </div>
                        <table width="100%">
                            <tr *ngIf="(typeOfCompany == 'BusinessUnit')">
                                <td width="20%">
                                    <label for="useCorporateCredential" class="control-label">
                                    Use Corporate Credential :
                                    </label>
                                </td>
                                <td style="padding-bottom: 10px; vertical-align: middle" width="70%">
                                    <div class="onoffswitch onoffswitch-success topheight"
                                        style="display: inline-block; margin-top: 15px">
                                        <input type="checkbox" name="todetect_4" class="onoffswitch-checkbox" [disabled]="readOnlyForClientOrBU"
                                            id="todetect_4" [(ngModel)]="preferences.useCorporateCredential">
                                        <label class="onoffswitch-label lbl" for="todetect_4" [ngClass]="{'disable-element': readOnlyForClientOrBU}">
                                            <div class="onoffswitch-inner"></div>
                                            <div class="onoffswitch-switch swch"></div>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                        </table>
                        <div class="text-left error" [ngClass]="{'save-credential-message-for-bu':typeOfCompany == 'BusinessUnit', 'save-credential-message': typeOfCompany !== 'BusinessUnit'}" *ngIf="valid && hasUnsavedJobBoardCredentials">
                            Please save the credentials
                        </div>
                        <div class="text-right" style="padding: 7px;">
                            <button type="button" class="btn btn-primary"
                                *ngIf="(typeOfCompany == 'Company' || typeOfCompany == 'Host') || (typeOfCompany == 'BusinessUnit' && preferences.daxtraDbNamePresentAtCompany)"
                                (click)="showAddJobBoardKeyForm()"
                                [disabled]="readOnlyForClientOrBU || (!clientOrBuCreationInProgress && !clientOrBuUpdateInProgress && isCompanyVendor) || showAddJobBoardCredentialsFormFlag">
                                Add Credentials
                            </button>
                        </div>
                        <table width="100%" class="table table-bordered">
                            <thead>
                                <tr>
                                    <td align="center" width="15%"><label class="control-label">Job Source
                                            Type</label>
                                    </td>
                                    <td align="center" width="25%"><label class="control-label">Username /
                                            Email</label>
                                    </td>
                                    <td align="center" width="15%"><label class="control-label">Password</label>
                                    </td>
                                    <td align="center" width="15%"><label class="control-label">Key</label></td>
                                    <td align="center" width="15%"><label class="control-label">Additional
                                            Parameters</label></td>
                                    <td align="center" width="15%"><label class="control-label">Actions</label></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let jobBoardCredential of preferences.jobBoardCredentialList; let $index = index; trackBy: trackByIndex"
                                    [ngClass]="{'danger': jobBoardCredential.delete, 'info': !jobBoardCredential.editable, 'warning': (jobBoardCredential.password != null && jobBoardCredential.key != null)}">
                                    <td>
                                        <div *ngIf="!jobBoardCredential.showEditForm">
                                            {{jobBoardCredential.sourceType}}
                                        </div>
                                        <div *ngIf="jobBoardCredential.showEditForm">
                                            <select class="form-control" name="editJobBoardCredentialSourceType-{{$index}}"
                                                id="editJobBoardCredentialSourceType-{{$index}}" [(ngModel)]="jobBoardCredential.source"
                                                (ngModelChange)="jobBoardCredentialsEditSourceTypeChanged(jobBoardCredential)" required>
                                                <option *ngFor="let source of jobSourceType" [ngValue]="source">{{source.sourceType}}</option>
                                            </select>
                                        </div>
                                    </td>
                                    <td>
                                        <div *ngIf="!jobBoardCredential.showEditForm">
                                            {{jobBoardCredential.userName}}
                                        </div>
                                        <div *ngIf="jobBoardCredential.showEditForm">
                                            <input type="text" name="editJobBoardCredentialUserName-{{$index}}"
                                                id="editJobBoardCredentialUserName-{{$index}}" class="form-control"
                                                [(ngModel)]="jobBoardCredential.userName" required autocomplete="off">
                                        </div>
                                    </td>
                                    <td>
                                        <div *ngIf="jobBoardCredential.credentialsAddedWithKey">
                                            Password is not required.
                                        </div>
                                        <div *ngIf="!jobBoardCredential.credentialsAddedWithKey && !jobBoardCredential.showEditForm">
                                            ****
                                        </div>
                                        <div *ngIf="jobBoardCredential.showEditForm && !jobBoardCredential.credentialsAddedWithKey">
                                            <input type="password" name="editJobBoardCredentialPassword-{{$index}}"
                                                id="editJobBoardCredentialPassword-{{$index}}" class="form-control"
                                                [(ngModel)]="jobBoardCredential.password" required autocomplete="off">
                                        </div>
                                    </td>
                                    <td>
                                        <div *ngIf="!jobBoardCredential.showEditForm">
                                            <span *ngIf="jobBoardCredential.key == null && !jobBoardCredential.credentialsAddedWithKey">Key
                                                will be generated.</span>
                                            <span
                                                *ngIf="jobBoardCredential.key != null && (!jobBoardCredential.edited || jobBoardCredential.editable)">{{jobBoardCredential.key}}</span>
                                        </div>
                                        <div *ngIf="jobBoardCredential.showEditForm">
                                            <span *ngIf="jobBoardCredential.key == null && !jobBoardCredential.credentialsAddedWithKey">Key
                                                will be generated.</span>
                                            <input type="text" *ngIf="jobBoardCredential.credentialsAddedWithKey"
                                                name="jobBoardCredentialKey-{{$index}}" id="jobBoardCredentialKey-{{$index}}" class="form-control"
                                                [(ngModel)]="jobBoardCredential.key" required autocomplete="off">
                                        </div>
                                    </td>
                                    <td>
                                        <div *ngIf="!jobBoardCredential.showEditForm">
                                            <span
                                                *ngIf="jobBoardCredential.loginOptions == null && !jobBoardCredential.credentialsAddedWithKey && jobBoardCredential.sourceType !== 'Dice'">Not
                                                required.</span>
                                            <span
                                                *ngIf="jobBoardCredential.loginOptions == null && !jobBoardCredential.credentialsAddedWithKey && jobBoardCredential.sourceType == 'Dice'">--</span>
                                            <span *ngIf="jobBoardCredential.loginOptions != null">{{jobBoardCredential.loginOptions}}</span>
                                        </div>
                                        <div *ngIf="jobBoardCredential.showEditForm">
                                            <span
                                                *ngIf="jobBoardCredential.loginOptions == null && !jobBoardCredential.credentialsAddedWithKey && jobBoardCredential.sourceType !== 'Dice'">Not
                                                Required.</span>
                                            <span *ngIf="jobBoardCredential.loginOptions == null && jobBoardCredential.credentialsAddedWithKey">Not
                                                Required.</span>
                                            <input type="text"
                                                *ngIf="!jobBoardCredential.credentialsAddedWithKey && jobBoardCredential.sourceType == 'Dice'"
                                                name="jobBoardCredentialLoginOptions-{{$index}}" id="jobBoardCredentialLoginOptions-{{$index}}"
                                                class="form-control" [(ngModel)]="jobBoardCredential.loginOptions" autocomplete="off">
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <a *ngIf="jobBoardCredential.delete" uib-tooltip="Undo Delete" data-toggle="modal"
                                            (click)="cancelDeleteJobBoardKey(jobBoardCredential)" class="table-link danger">
                                            <span class="fa-stack">
                                                <i class="fa fa-square fa-stack-2x"></i>
                                                <i class="fa fa-undo fa-stack-1x fa-inverse"></i>
                                            </span>
                                        </a>
                                        <a *ngIf="!jobBoardCredential.delete && !jobBoardCredential.showEditForm && !jobBoardCredential.edited && !jobBoardCredential.credentialsAddedWithKey"
                                            uib-tooltip="Edit Credentials" (click)="showEditJobBoardKeyForm(jobBoardCredential)"
                                            style="margin : 0px;" class="table-link primary">
                                            <span class="fa-stack">
                                                <i class="fa fa-square fa-stack-2x"></i>
                                                <i class="fas fa-pencil-alt fa-stack-1x fa-inverse"></i>
                                            </span>
                                        </a>
                                        <a *ngIf="!jobBoardCredential.delete && !jobBoardCredential.showEditForm && !jobBoardCredential.edited"
                                            [ngClass]="{'only-delete-icon': jobBoardCredential.credentialsAddedWithKey}"
                                            uib-tooltip="Delete Credentials" data-toggle="modal"
                                            [class.disabled]="!clientOrBuCreationInProgress && !clientOrBuUpdateInProgress && isCompanyVendor"
                                            (click)="deleteJobBoardDetails(jobBoardCredential)" class="table-link danger">
                                            <span class="fa-stack">
                                                <i class="fa fa-square fa-stack-2x"></i>
                                                <i class="far fa-trash-alt fa-stack-1x fa-inverse"></i>
                                            </span>
                                        </a>
                                        <a *ngIf="!jobBoardCredential.delete && jobBoardCredential.showEditForm" uib-tooltip="Update Credentials"
                                            (click)="updateEditJobBoardKeyForm(jobBoardCredential, $index)" style="margin : 0px;"
                                            class="table-link primary">
                                            <span class="fa-stack" [ngClass]="{'highlight-save-button': valid && hasUnsavedJobBoardCredentials}">
                                                <i class="fa fa-square fa-stack-2x"></i>
                                                <i class="fa fa-save fa-stack-1x fa-inverse"></i>
                                            </span>
                                        </a>
                                        <a *ngIf="(!jobBoardCredential.delete && jobBoardCredential.showEditForm) || jobBoardCredential.edited"
                                            uib-tooltip="Undo Edit" data-toggle="modal" (click)="cancelEditJobBoardKeyForm($index)"
                                            class="table-link danger">
                                            <span class="fa-stack">
                                                <i class="fa fa-square fa-stack-2x"></i>
                                                <i class="fa fa-undo fa-stack-1x fa-inverse"></i>
                                            </span>
                                        </a>
                                    </td>
                                </tr>
                                <tr *ngIf="showAddJobBoardCredentialsFormFlag">
                                    <td>
                                        <div>
                                            <select class="form-control" name="newJobBoardCredentialSourceType" id="newJobBoardCredentialSourceType"
                                                [(ngModel)]="newJobBoardCredential.source"
                                                (ngModelChange)="jobBoardCredentialsAddSourceTypeChanged($index)" required>
                                                <option [ngValue]="null"></option>
                                                <option *ngFor="let source of jobSourceType" [ngValue]="source">{{source.sourceType}}</option>
                                            </select>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <input type="text" name="newJobBoardCredentialUserName" id="newJobBoardCredentialUserName"
                                                class="form-control" [(ngModel)]="newJobBoardCredential.userName" required autocomplete="off">
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <label *ngIf="newJobBoardCredential.credentialsAddedWithKey">Password is not
                                                required.</label>
                                            <input type="password" *ngIf="!newJobBoardCredential.credentialsAddedWithKey"
                                                name="newJobBoardCredentialPassword" id="newJobBoardCredentialPassword" class="form-control"
                                                [(ngModel)]="newJobBoardCredential.password" required autocomplete="off">
                                        </div>
                                    </td>
                                    <td>
                                        <label *ngIf="!newJobBoardCredential.credentialsAddedWithKey">Key will be
                                            generated.</label>
                                        <input type="text" *ngIf="newJobBoardCredential.credentialsAddedWithKey" name="newJobBoardCredentialKey"
                                            id="newJobBoardCredentialKey" class="form-control" [(ngModel)]="newJobBoardCredential.key" required
                                            autocomplete="off">
                                    </td>
                                    <td>
                                        <label
                                            *ngIf="newJobBoardCredential.credentialsAddedWithKey || (!newJobBoardCredential.credentialsAddedWithKey && newJobBoardCredential.sourceType !== 'Dice')">Not
                                            Required.</label>
                                        <input type="text"
                                            *ngIf="!newJobBoardCredential.credentialsAddedWithKey && newJobBoardCredential.sourceType == 'Dice'"
                                            name="newJobBoardCredentialLoginOptions" id="newJobBoardCredentialLoginOptions" class="form-control"
                                            [(ngModel)]="newJobBoardCredential.loginOptions" autocomplete="off">
                                    </td>
                                    <td class="text-center">
                                        <a uib-tooltip="Add" (click)="addJobBoardKey()" style="margin : 0px;" class="table-link primary mr-2">
                                            <span class="fa-stack" [ngClass]="{'highlight-save-button': valid && hasUnsavedJobBoardCredentials}">
                                                <i class="fa fa-square fa-stack-2x"></i>
                                                <i class="fa fa-save fa-stack-1x fa-inverse"></i>
                                            </span>
                                        </a>
                                        <a uib-tooltip="Cancel Add" data-toggle="modal" (click)="cancelAddJobBoardKey()" class="table-link danger">
                                            <span class="fa-stack">
                                                <i class="fa fa-square fa-stack-2x"></i>
                                                <i class="fa fa-times fa-stack-1x fa-inverse"></i>
                                            </span>
                                        </a>
                                    </td>
                                </tr>
                                <tr
                                    *ngIf="((preferences.jobBoardCredentialList == null || preferences.jobBoardCredentialList.length == 0) && !showAddJobBoardCredentialsFormFlag )">
                                    <td colspan="5" align="center">
                                        No job board credentials exist.
                                    </td>
                                    <td></td>
                                </tr>
                            </tbody>
                           
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
